import React, { useState, useEffect } from "react";
import { overlayButtonStyle } from "../../../utils/layout";
import Button from "react-bootstrap/Button";
import { useLocation, useNavigate } from "react-router-dom";
import XframeContainer from "../xframedItems/XframeContainer";
import { urls } from "../../../utils/urls";
import { makeGetRequest } from "../../../utils/api";
import NoResourceMessage from "../resources/NoResourceMessage";

function AfternoonMeetingXframe() {
  const [xframe, setXframe] = useState("");
  const [name, setName] = useState("");
  const [dataPulled, setDataPulled] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const isLandscape = () =>
      window.matchMedia("(orientation:landscape)").matches,
    [orientation, setOrientation] = useState(
      isLandscape() ? "landscape" : "portrait"
    ),
    onWindowResize = () => {
      clearTimeout(window.resizeLag);
      window.resizeLag = setTimeout(() => {
        delete window.resizeLag;
        setOrientation(isLandscape() ? "landscape" : "portrait");
      }, 200);
    };

  const handleData = async () => {
    const response = await makeGetRequest(
      urls.resources + "?active=True",
      "",
      true
    );
    if (location.pathname.includes("afternoon-meeting")) {
      const meetingData = response.data.filter((item) => {
        return item.type === 2;
      });
      setXframe(meetingData[0].url);
      setName(meetingData[0].name);
    }
    if (location.pathname.includes("morning-meeting")) {
      const meetingData = response.data.filter((item) => {
        return item.type === 1;
      });
      setXframe(meetingData[0].url);
      setName(meetingData[0].name);
      setDataPulled(true);
    }
  };

  const backToHome = () => {
    navigate("/");
  };

  useEffect(
    () => (
      onWindowResize(),
      window.addEventListener("resize", onWindowResize),
      () => window.removeEventListener("resize", onWindowResize)
    ),
    []
  );

  useEffect(() => {
    handleData();
  }, []);

  return (
    <>
      {xframe && (
        <>
          <Button
            style={overlayButtonStyle(0)}
            onClick={() => backToHome()}
          >
            Back to Home
          </Button>
          <XframeContainer url={xframe} name={name} orientation={orientation} />
        </>
      )}
      {!xframe && dataPulled === true && (
        <NoResourceMessage />
      )}
    </>
  );
}

export default AfternoonMeetingXframe;
